import { ReadCampaign } from '@tinct/core-api-models';
import { useDeleteCampaign } from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { toast } from 'sonner';

type DeleteCampaignModalProps = {
  row: ReadCampaign;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleted?: () => void;
};

export const DeleteCampaignModal = ({
  row: campaign,
  open,
  onOpenChange,
  onDeleted,
}: DeleteCampaignModalProps) => {
  const { mutate: deleteCampaign, isPending } = useDeleteCampaign({
    onSuccess: () => {
      toast.success('Campaign deleted');
      onOpenChange(false);
      onDeleted?.();
    },
  });

  const handleConfirm = () => {
    if (!campaign.id) return;
    deleteCampaign({ campaignId: campaign.id });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] rounded-3xl p-8">
        <DialogHeader>
          <DialogTitle>Delete campaign</DialogTitle>
          <DialogDescription>
            <span className="font-semibold">{campaign.name}</span>
            {' will be permanently deleted.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-between">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
